module.exports = __webpack_public_path__ + "static/Appointments@0.25x-d8367b37a7469a03646d90b5bc18a65f.jpg";